export default __webpack_public_path__ + "static/brand_05-1e2e0286aa993705324824a55c6e58f5.png";